const initialValue = {
  data: [],
  error: "",
};

const faqReducer = (state = initialValue, action) => {
  switch (action.type) {
    case "GET_FAQ_SUCCESS":
      return {
        ...state,
        data: action.payload,
        error: "",
      };
    case "GET_FAQ_FAILURE":
      return {
        ...state,
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default faqReducer;
